// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { getElementFilterSelector } from '../../element/elementFilter/elementFilterSelector';

// Components
import ElementFilterUtil from '../header/currentBoardHeader/elementFilter/ElementFilterUtil';

const mapStateToProps = createStructuredSelector({
    elementFilter: getElementFilterSelector,
});

const MobileBoardHeaderUtils = ({ currentBoardId, elementFilter }) => {
    if (elementFilter) {
        return <ElementFilterUtil currentBoardId={currentBoardId} />;
    }

    return null;
};

MobileBoardHeaderUtils.propTypes = {
    currentBoardId: PropTypes.string.isRequired,
    elementFilter: PropTypes.object,
    breadcrumbObj: PropTypes.object,
};

export default connect(mapStateToProps)(MobileBoardHeaderUtils);
